import { ApiModule } from "@/api/api-module"
import routes from './routes'

class ApiConstructor extends ApiModule {
  //Признаки
  getProperties(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.properties).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  createPropertyFolder(data){
    if (data.parent_id===0) data.parent_id=null
    return new Promise((resolve, reject) => {
      this.http.put(routes.propertyFolder, data).then(
        response => {
          resolve(response.data.id)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  updatePropertyFolder(id, data){
    if (data.parent_id===0) data.parent_id=null
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.propertyFolder}/${id}`, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getFolder(id, type){
    let route = ''
    switch(type){
      case 'property': route = routes.propertyFolder; break
      case 'object': route = routes.objectsFolder; break
      case 'form': route = routes.settingFolder; break
    }
    return new Promise((resolve, reject) => {
      this.http.get(`${route}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  deleteFolder(id, type){
    let route = ''
    switch(type){
      case 'property': route = routes.propertyFolder; break
      case 'object': route = routes.objectsFolder; break
      case 'form': route = routes.settingFolder; break
    }
    return new Promise((resolve, reject) => {
      this.http.delete(`${route}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  restoreFolder(id, type){
    let route = ''
    switch(type){
      case 'property': route = routes.restorePropertyFolder; break
      case 'object': route = routes.restoreObjectsFolder; break
    }
    
    return new Promise((resolve, reject) => {
      this.http.get(`${route}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getPropertiesFolders(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.propertyFolders}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  createProperty(data){
    if (data.parent_id===0) data.parent_id=null
    data.identified = data.name
    return new Promise((resolve, reject) => {
      this.http.put(routes.property, data).then(
        response => {
          resolve(response.data.id)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  updateProperty(id, data){
    if (data.parent_id===0) data.parent_id=null
    data.identified = data.name
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.property}/${id}`, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getObject(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.object}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getProperty(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.property}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  createObject(data){
    if (data.parent_id===0) data.parent_id=null
    data.identified = data.name
    return new Promise((resolve, reject) => {
      this.http.put(routes.objects, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  updateObject(id, data){
    if (data.parent_id===0) data.parent_id=null
    data.identified = data.name
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.object}/${id}`, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  deleteEntity(id, type){
    let route = ''
    switch(type){
      case 'property': route = routes.property; break
      case 'object': route = routes.object; break
      case 'form': route = routes.setting; break
    }
    return new Promise((resolve, reject) => {
      this.http.delete(`${route}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  restoreEntity(id, type){
    let route = ''
    switch(type){
      case 'property': route = routes.restoreProperty; break
      case 'object': route = routes.restoreObject; break
    }
    return new Promise((resolve, reject) => {
      this.http.get(`${route}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getProperty(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.property}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getObjects(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.objects).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getObjectsFolders(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.objectsFolders}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  createObjectsFolder(data){
    if (data.parent_id===0) data.parent_id=null
    return new Promise((resolve, reject) => {
      this.http.put(routes.objectsFolder, data).then(
        response => {
          resolve(response.data.id)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  updateObjectsFolder(id, data){
    if (data.parent_id===0) data.parent_id=null
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.objectsFolder}/${id}`, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getFormsTree(){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.settings}/admin`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getFormsFolders(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.settingFolders}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  createFormFolder(data){
    if (data.parent_id===0) data.parent_id=null
    return new Promise((resolve, reject) => {
      this.http.put(routes.settingFolder, data).then(
        response => {
          resolve(response.data.id)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  updateFormFolder(id, data){
    if (data.parent_id===0) data.parent_id=null
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.settingFolder}/${id}`, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  createForm(data){
    if (data.parent_id===0) data.parent_id=null
    return new Promise((resolve, reject) => {
      this.http.put(routes.setting, data).then(
        response => {
          resolve(response.data.id)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  updateForm(id, data){
    if (data.parent_id===0) data.parent_id=null
    return new Promise((resolve, reject) => {
      this.http.patch(`${routes.setting}/${id}`, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getForm(id){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.setting}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getWatchers(){
    return new Promise((resolve, reject) => {
      this.http.get(routes.watchers).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  addWatcher(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.addWatcher, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  assignedObjects(id, type){
    return new Promise((resolve, reject) => {
      this.http.get(`${routes.assignedObjects}/${type}/${id}`).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  propertiesData(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.propertiesData, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  countMatch(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.countMatch, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  showMatch(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.showMatch, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  objectValues(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.objectValues, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  mergeObjects(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.mergeObjects, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
  getDataTable(data){
    return new Promise((resolve, reject) => {
      this.http.post(routes.getDataTable, data).then(
        response => {
          resolve(response.data)
        },
        error => {
          reject(this.normalizeError(error))
        }
      )
    })
  }
  
}

let apiConstructor = new ApiConstructor("constructor")
export default apiConstructor


// WEBPACK FOOTER //
// ./src/apps/analytics/api/constructor/index.js